import { render } from "./calendar-configurator.vue?vue&type=template&id=4a7b2b62&scoped=true"
import script from "./calendar-configurator.vue?vue&type=script&lang=js"
export * from "./calendar-configurator.vue?vue&type=script&lang=js"

import "./calendar-configurator.vue?vue&type=style&index=0&id=4a7b2b62&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7b2b62"]])

export default __exports__